import { t } from "@/i18n-js/instance";
import { ListingCard } from "../ListingCard";
import { LabelWithDetail } from "./LabelWithDetail";

interface SpaceListCardProps {
  resources: Array<{ name: string; id: string; space_type?: string }>;
}

export const SpaceListCard = ({ resources }: SpaceListCardProps) => {
  const getSpaceTypeLabel = (space_type?: string) => {
    if (!space_type) return null;

    const spaceNameLabel = t(
      `settings.spaces.space_types.${space_type}`,
    ).toLowerCase();
    return t("help_widget.copilot.chat_card.space_types", {
      space_type: spaceNameLabel,
    });
  };

  return (
    <ListingCard
      title={t("help_widget.copilot.chat_card.spaces")}
      resources={resources}
      emptyStateText={t("help_widget.copilot.chat_card.no_spaces_found")}
      renderItem={space => (
        <LabelWithDetail
          label={space.name}
          detail={getSpaceTypeLabel(space.space_type)}
        />
      )}
      getItemKey={space => space.id}
    />
  );
};
